﻿(function() {
	'use strict';

	angular
		.module("portalApp")
		.service("eproService", EproService);

	/*
	 * @ngInject
	 */
	function EproService($log, $http, appSession, appConfig) {

		return {
			getQrCode: getQrCode,
			getResponseAudioSourceUrl: getResponseAudioSourceUrl,
			getCreateSubjectData: getCreateSubjectData,
			getEditSubjectData: getEditSubjectData,
			activateSubject: activateSubject,
			deactivateSubject: deactivateSubject,
			createSubject: createSubject,
			editSubject: editSubject,
			getCloseVisitData: getCloseVisitData,
			getCanCloseVisit: getCanCloseVisit,
			closeVisit: closeVisit,
			getSendPinData: getSendPinData,
			sendPin: sendPin,
			editContact: editContact,
			getEditContactData: getEditContactData,
			getScoringResults: getScoringResults,
			getAlertsTriggered: getAlertsTriggered,
			getDailySessions: getDailySessions,
			getSessionData: getSessionData,
			getResponses: getResponses,
			getParameters: getParameters,
			getParameterDefinitions: getParameterDefinitions,
			getEcoaPhoneQuestionnaire: getEcoaPhoneQuestionnaire,
			getClosedVisit: getClosedVisit,
			getClinicalPrompts: getClinicalPrompts,
			getISpiroEproDeviceActions: getISpiroEproDeviceActions,
			getStudyConfiguration: getStudyConfiguration,
			getAdditionalAttributes: getAdditionalAttributes,
			dispenseDevice: dispenseDevice,
			generateQrCode: generateQrCode,
			resetPin: resetPin,
			getProvisionedAppIds: getProvisionedAppIds,
			resetPinQR: resetPinQR,
			closeDeviceInit: closeDeviceInit,
			closeDevice: closeDevice,
			lostDevice: lostDevice,
			getDeviceState: getDeviceState,
			getProvisionedAppIdsForClose: getProvisionedAppIdsForClose,
			getISpiroEproDailySessions: getISpiroEproDailySessions,
			getISpiroEproFormActivity: getISpiroEproFormActivity,
			getISpiroEproQuestionResponse: getISpiroEproQuestionResponse,
			getISpiroEproFormJson: getISpiroEproFormJson,
			getIspiroEproNotifications: getIspiroEproNotifications,
			getNotificationResults: getNotificationResults,
			getIspiroEproSessionLevelNotifications: getIspiroEproSessionLevelNotifications,
			getIspiroEproSessionLevelNotificationsCount: getIspiroEproSessionLevelNotificationsCount,
			generateStradosCoughQrCode: generateStradosCoughQrCode,
			closeStradosCough: closeStradosCough,
			getHomeBpAdditionalData: getHomeBpAdditionalData,
			getHomeBpStudyConfiguration: getHomeBpStudyConfiguration,
			updateHomeBpSubject: updateHomeBpSubject,
			getHomeBpSubject:getHomeBpSubject,
			scheduleHomeBpSubject: scheduleHomeBpSubject,
			generateHomeBpQrCode: generateHomeBpQrCode,
			getProtocolSetupLabels: getProtocolSetupLabels
		};

		function getQrCode(siteId, eproSubjectId) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.qrCode
					.supplant({'studyId': currentStudy.id, 'eproSubjectId': eproSubjectId,
										 'siteId': siteId, 'studyModeId': currentStudy.studyModeId});
			return $http.get(url);
		}

		function getResponseAudioSourceUrl(siteId, eproSubjectId, response) {
			var currentStudy = appSession.getStudy();
			var token = appSession.getSessionToken();

			var url = appConfig.apiUrls.clinicalData.epro.audioData
				.supplant({ 'studyId': currentStudy.id, 'responseId': response.responseId,
							'eproSubjectId': eproSubjectId, 'siteId': siteId,
							'studyModeId': currentStudy.studyModeId, 'token': token });
			return url;
		}

		function getEcoaPhoneQuestionnaire(siteId, eproSubjectId, eventId, tdtId) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.ecoaphoneQuestionnaire
					.supplant({'studyId': currentStudy.id, 'eproSubjectId': eproSubjectId,
										 'siteId': siteId, 'studyModeId': currentStudy.studyModeId,
										 'tdtId': tdtId, 'eventId': eventId});
			return $http.get(url);
		}

		function getScoringResults(siteId, eproSubjectId, eventId, tdtId) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.scoringResults
					.supplant({'studyId': currentStudy.id, 'studyModeId': currentStudy.studyModeId,
										 'siteId': siteId, 'eproSubjectId': eproSubjectId,
										 'tdtId': tdtId, 'eventId': eventId});
			return $http.get(url);
		}
		
		function getAlertsTriggered(siteId, eproSubjectId, eventIds, tdtId, alertType) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.alertsTriggered
					.supplant({'studyId': currentStudy.id, 'studyModeId': currentStudy.studyModeId,
										'siteId': siteId, 'eproSubjectId': eproSubjectId,
										 'tdtId': tdtId, 'alertType': alertType === undefined ? '' : alertType});

			var eventIdArray = getArrayForString(eventIds);

			eventIdArray.forEach(function (el) {
				url = addParameterToUrl(url, 'eventId', el.trim());
			});

			return $http.get(url);
		}

		function getClosedVisit(siteId, eproSubjectId, eventId, tdtId) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.closedVisit
				.supplant({'studyId': currentStudy.id, 'studyModeId': currentStudy.studyModeId,
									 'siteId': siteId, 'eproSubjectId': eproSubjectId,
									 'tdtId': tdtId, 'eventId': eventId});
			return $http.get(url);
		}

		function getParameterDefinitions(mdtId) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.ecoa.parameterDefs
				.supplant({'studyId': currentStudy.id, 'mdtId': mdtId});
			return $http.get(url);
		}

		function getClinicalPrompts(moduleId, languageId, mdtId) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.ecoa.clinicalPrompts
					.supplant({'studyId': currentStudy.id, 'mdtId': mdtId,
										 'moduleId': moduleId, 'languageId': languageId});
			return $http.get(url);
		}

		function getParameters(siteId, eproSubjectId, eventId, sessionDate, sessionTime, sessionTypeId, mdtId) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.ecoa.parameters
				.supplant({'studyId': currentStudy.id, 'studyModeId': currentStudy.studyModeId,
									'siteId': siteId, 'eproSubjectId': eproSubjectId,
									'sessionDate': sessionDate, 'sessionTime': sessionTime,
									 sessionTypeId,
									'mdtId': mdtId, 'eventId': eventId || ''});
			return $http.get(url);
		}

		function getResponses(siteId, eproSubjectId, eventId, sessionDate, sessionTime, sessionTypeId, tdtId, mdtId, sessionId) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.ecoa.sessionResponses
				.supplant({'studyId': currentStudy.id, 'studyModeId': currentStudy.studyModeId,
									'siteId': siteId, 'eproSubjectId': eproSubjectId,
									'sessionDate': sessionDate, 'sessionTime': sessionTime,
									 sessionTypeId,
									'tdtId': tdtId, 'mdtId': mdtId, 'eventId': eventId || '',
									'sessionId': sessionId || '' });
			return $http.get(url);
		}

		function getDailySessions(siteId, eproSubjectId, eventId, tdtId, mdtId, oDataQuery) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.ecoa.dailySessions
				.supplant({'studyId': currentStudy.id, 'studyModeId': currentStudy.studyModeId,
									'siteId': siteId, 'eproSubjectId': eproSubjectId,
									 'oDataQuery': oDataQuery || '',
									 'tdtId': tdtId, 'mdtId': mdtId, 'eventId': (!eventId || eventId == 0) ? '' : eventId});
			return $http.get(url);
		}

		function getSessionData(siteId, eproSubjectId, sessionDate, eventIds, mdtId, timeout) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.ecoa.sessionData
				.supplant({'studyId': currentStudy.id, 'studyModeId': currentStudy.studyModeId, 'siteId': siteId,
									'eproSubjectId': eproSubjectId, 'sessionDate': sessionDate,'mdtId': mdtId
				});

			var eventIdArray = getArrayForString(eventIds);

			eventIdArray.forEach(function (el) {
				url = addParameterToUrl(url, 'eventId', el.trim());
			});

			return $http.get(url, { timeout: timeout.promise });
		}

		function getArrayForString(arrayString) {
			var idArray = [];
			if (arrayString && arrayString.indexOf(',') > 0) {
				idArray = arrayString.split(',');
			}
			else if (arrayString) {
				idArray.push(arrayString);
			}
			return idArray;
		}

		function addParameterToUrl(url, paramName, paramValue) {
			url += '&' + paramName + '=' + paramValue;
			return url;
		}

		function getCloseVisitData(eproSubjectId) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.closeVisit.data.supplant(
				{ 'studyId': currentStudy.id, 'studyModeId': currentStudy.studyModeId,
					'eproSubjectId': eproSubjectId});
			return $http.get(url);
		}

		function getCanCloseVisit(eproSubjectId) {
			if (!eproSubjectId) {
				return null;
			}

			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.closeVisit.canClose.supplant(
				{ 'studyId': currentStudy.id, 'studyModeId': currentStudy.studyModeId,
					'eproSubjectId': eproSubjectId});
			return $http.get(url);
		}

		function getCreateSubjectData(countryId, siteId) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.createSubject.data.supplant(
				{ 'studyId': currentStudy.id, 'studyModeId': currentStudy.studyModeId,
					'countryId': countryId || '0', 'siteId': siteId || '0'});
			return $http.get(url);
		}

		function getEditSubjectData(countryId, siteId, eproSubjectId, subjectId) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.editSubject.data.supplant(
				{ 'studyId': currentStudy.id, 'studyModeId': currentStudy.studyModeId,
					'countryId': countryId || '0', 'siteId': siteId || '0', 'eproSubjectId': eproSubjectId,
					'subjectId': subjectId});
			return $http.get(url);
		}

		function deactivateSubject(siteId, eproSubjectId) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.editSubject.deactivate.supplant(
				{ 'studyId': currentStudy.id, 'studyModeId': currentStudy.studyModeId,
					'siteId': siteId || '0', 'eproSubjectId': eproSubjectId});
			return $http.put(url);
		}

		function activateSubject(siteId, eproSubjectId) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.editSubject.activate.supplant(
				{ 'studyId': currentStudy.id, 'studyModeId': currentStudy.studyModeId,
					'siteId': siteId || '0', 'eproSubjectId': eproSubjectId});
			return $http.put(url);
		}

		function getEditContactData(eproSubjectId) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.contact.data.supplant(
				{ 'studyId': currentStudy.id, 'studyModeId': currentStudy.studyModeId,
					'eproSubjectId': eproSubjectId});
			return $http.get(url);
		}

		function getSendPinData(eproSubjectId) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.pin.data.supplant(
				{ 'studyId': currentStudy.id, 'studyModeId': currentStudy.studyModeId,
					'eproSubjectId': eproSubjectId});
			return $http.get(url);
		}

		function editSubject(subject, eproSubjectId, subjectId) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.editSubject.update.supplant(
				{ 'studyId': currentStudy.id, 'studyModeId': currentStudy.studyModeId,
					'eproSubjectId': eproSubjectId, 'subjectId': subjectId});
			return $http.put(url, subject);
		}

		function closeVisit(subjectId, eproSubjectId, visit) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.closeVisit.close.supplant(
				{ 'studyId': currentStudy.id, 'studyModeId': currentStudy.studyModeId,
					'eproSubjectId': eproSubjectId, 'subjectId': subjectId});

			return $http.post(url, visit);
		}

		function createSubject(subject) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.createSubject.create.supplant(
				{ 'studyId': currentStudy.id, 'studyModeId': currentStudy.studyModeId });
			return $http.post(url, subject);
		}

		function sendPin(siteId, eproSubjectId, pinData) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.pin.send.supplant(
				{ 'studyId': currentStudy.id, 'studyModeId': currentStudy.studyModeId, 'siteId': siteId,
					'eproSubjectId': eproSubjectId});
			var apiData = {
				'useExistingPin': pinData.changePin === 0,
				'Pin': pinData.newPin,
				'generatePin': pinData.changePin === 1,
				'sendPinToSubjectEmail': pinData.sendPin === 1,
				'sendPinToEmail': pinData.pinEmail
			};
			return $http.post(url, apiData);
		}

		function editContact(siteId, eproSubjectId, editContactData) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.contact.update.supplant(
				{ 'studyId': currentStudy.id, 'studyModeId': currentStudy.studyModeId, 'siteId': siteId,
					'eproSubjectId': eproSubjectId});

			var apiData = {
				clearPhone: editContactData.deletePhone,
				clearMobile: editContactData.deleteMobile,
				clearEmail: editContactData.deleteEmail,
				email: editContactData.email
			};

			if (editContactData.phoneFormat === 0) {
				apiData.phone = editContactData.phoneUS;
				apiData.mobile = editContactData.mobileUS;
			}
			else {
				apiData.phone = editContactData.phoneInternational;
				apiData.mobile = editContactData.mobileInternational;
			}

			return $http.put(url, apiData);
		}

		function getStudyConfiguration() {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.studyConfiguration.supplant(
				{ 'studyId': currentStudy.id, 'studyModeId': currentStudy.studyModeId });
			
			return $http.get(url);
		}

		function getAdditionalAttributes(siteId, subjectId) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.additionalAttributes.supplant(
				{ 'studyId': currentStudy.id, 'siteId': siteId, 'subjectId': subjectId, 'studyModeId': currentStudy.studyModeId });
			
			return $http.get(url);
		}

		function dispenseDevice(siteId, subjectId, data) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.dispense.supplant(
				{ 'studyId': currentStudy.id, 'siteId': siteId, 'subjectId': subjectId, 'studyModeId': currentStudy.studyModeId });
			var apiData = data;

			return $http.put(url, apiData);
		}

		function generateQrCode(data) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.generateQRCode.supplant({
				'studyModeId': currentStudy.studyModeId
			});
			var apiData = data;

			return $http.post(url, apiData);
		}

		function resetPin(subjectId) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.resetPin.supplant({
				'subjectId': subjectId,
				'studyModeId': currentStudy.studyModeId
			});

			return $http.get(url);
		}

		function getProvisionedAppIds(siteId, technicalSubjectId) {
			const currentStudy = appSession.getStudy();
			const url = appConfig.apiUrls.clinicalData.epro.provisionedAppIds.supplant({
				'studyId': currentStudy.id,
				'studyModeId': currentStudy.studyModeId,
				siteId,
				subjectId: technicalSubjectId
			});

			return $http.get(url);
		}

		function resetPinQR(appId, data, siteId, subjectId) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.resetPinQR.supplant({
				'appId': appId,
				'studyModeId': currentStudy.studyModeId,
				'studyId': currentStudy.id,
				'subjectId': subjectId,
				'siteId': siteId
			});

			var apiData = data;

			return $http.post(url, apiData);
		}

		function closeDeviceInit(subjectId) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.resetPin.supplant({
				'subjectId': subjectId,
				'studyModeId': currentStudy.studyModeId
			});

			return $http.get(url);
		}

		function getProvisionedAppIdsForClose(siteId, subjectId) {
			const currentStudy = appSession.getStudy();
			const url = appConfig.apiUrls.clinicalData.epro.provisionedAppIds.supplant({
				'studyId': currentStudy.id,
				'studyModeId': currentStudy.studyModeId,
				siteId,
				subjectId
			});

			return $http.get(url);
		}

		function closeDevice(appId, data, siteId) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.close.supplant({
				'appId': appId,
				'studyModeId': currentStudy.studyModeId,
				'studyId': currentStudy.id,
				'siteId': siteId
			});

			var apiData = data;
			return $http.post(url, apiData);
		}

		function lostDevice(appId, data, siteId) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.lost.supplant({
				'appId': appId,
				'studyModeId': currentStudy.studyModeId,
				'studyId': currentStudy.id,
				'siteId': siteId
			});

			var apiData = data;

			return $http.post(url, apiData);
		}

		function getDeviceState(appId) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.currentState.supplant({
				'appId': appId,
				'studyModeId': currentStudy.studyModeId
			});

			return $http.get(url);
		}
		
		function getISpiroEproDeviceActions(countryId, siteId, subjectId, subjectKey) {
			const currentStudy = appSession.getStudy();
			const url = appConfig.apiUrls.clinicalData.epro.iSpiroEproDeviceActions.supplant({
				'studyId': currentStudy.id,
				'studyModeId': currentStudy.studyModeId,
				countryId,
				siteId,
				subjectId,
				subjectKey
			});
		
			return $http.get(url);
		}

		function getISpiroEproDailySessions(siteId, eproSubjectId, oDataQuery) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.eproSessionViewer.dailySessions
				.supplant({'studyId': currentStudy.id, 'studyModeId': currentStudy.studyModeId,
									'siteId': siteId, 'eproSubjectId': eproSubjectId,
									 'oDataQuery': oDataQuery || ''});
			return $http.get(url);
		}


		function getISpiroEproFormActivity(eproSubjectId, sessionDate) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.eproSessionViewer.formActivity
				.supplant({'studyId': currentStudy.id, 'studyModeId': currentStudy.studyModeId,
									'eproSubjectId': eproSubjectId,
									'sessionDate': sessionDate});
			return $http.get(url);
		}

		function getISpiroEproQuestionResponse(eproSubjectId, globalFormDetailId, transmittalNumber) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.eproSessionViewer.questionResponse
				.supplant({'studyId': currentStudy.id, 'studyModeId': currentStudy.studyModeId,
									'eproSubjectId': eproSubjectId,
									'globalFormDetailId': globalFormDetailId,
									'transmittalNumber': transmittalNumber});					
			return $http.get(url);
		}

		function getISpiroEproFormJson(eproSubjectId, transmittalNumber) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.eproSessionViewer.formJson
				.supplant({'studyId': currentStudy.id, 'transmittalNumber': transmittalNumber});
				return $http.get(url);
		}

		function getIspiroEproNotifications(eproSubjectId, eventId){
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.eproSessionViewer.notifications
				.supplant({'studyId': currentStudy.id, 'studyModeId': currentStudy.studyModeId,
									'eproSubjectId': eproSubjectId,
									'eventId': eventId});
			return $http.get(url);
		}

		function getNotificationResults(subjectId) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.eproSessionViewer.notificationsTriggered
					 .supplant({'studyId': currentStudy.id,
							   'studyModeId': currentStudy.studyModeId,
							    'eproSubjectId': subjectId});
			return $http.get(url);
		}

		function getIspiroEproSessionLevelNotifications(eproSubjectId, patientVisitInfoId) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.eproSessionViewer.notificationsSessionLevel
				.supplant({
					'studyId': currentStudy.id,
					'studyModeId': currentStudy.studyModeId,
					'eproSubjectId': eproSubjectId,
					'patientVisitInfoId': patientVisitInfoId
				});
			return $http.get(url);
		}

		function getIspiroEproSessionLevelNotificationsCount(eproSubjectId, sessionDate) {	
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.eproSessionViewer.notificationsSessionLevelCount
				.supplant({
					'studyId': currentStudy.id,
					'eproSubjectId': eproSubjectId,
					'sessionDate': sessionDate
				});
			return $http.get(url);
		}
		

		function generateStradosCoughQrCode(siteId, subjectId) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.generateStradosCoughQrCode;
			
			var apiData = {
				studyId: currentStudy.number,
				siteId: siteId,
				subjectId: subjectId
			};

			return $http.post(url, apiData);
		}

		function closeStradosCough(payload) {
			var url = appConfig.apiUrls.clinicalData.epro.closeStradosCough;
			
			return $http.post(url, payload);
		}
		
		function getHomeBpAdditionalData ()
		{
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.homeBpAdditionalData.supplant(
				{ 'studyId': currentStudy.id , 'studyAccount': currentStudy.number });
			return $http.get(url);
		}

		function getHomeBpStudyConfiguration() {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.homeBpStudyConfiguration.supplant(
				{ 'studyId': currentStudy.id , 'studyAccount': currentStudy.number });
			return $http.get(url);
		}

		function updateHomeBpSubject(siteId, subjectId, data) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.homebpSubjectUpdate.supplant({
				'studyId': currentStudy.id,
				'studyAccount': currentStudy.number,
				'siteId': siteId,
				'subjectId': subjectId
			});
			
			return $http.put(url, data);
		}

		function getHomeBpSubject(siteId, subjectId) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.homebpSubjectGet.supplant({
				'studyId': currentStudy.id,
				'studyAccount': currentStudy.number,
				'siteId': siteId,
				'subjectId': subjectId
			});
			
			return $http.get(url);
		}

		function scheduleHomeBpSubject(data)
		{
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.homebpSchedule.supplant({
				'studyId': currentStudy.id,
			});
			return $http.post(url, data);
		}

		function generateHomeBpQrCode(data) {
			var currentStudy = appSession.getStudy();
			var url = appConfig.apiUrls.clinicalData.epro.generateHomeBpQrCode.supplant({
				'studyId': currentStudy.id,
			});
			return $http.post(url, data);
		}

		function getProtocolSetupLabels() {
			const currentStudy = appSession.getStudy();
			const url = appConfig.apiUrls.clinicalData.protocolSetupLabels.supplant({
				'studyId': currentStudy.id
			});
			return $http.get(url);
		}
	}
})();
